import { Eye, EyeOff } from 'lucide-react';
import React, { useState } from 'react';
import { useChatbot } from '../../../contexts/ChatbotContext';
import { useAISettings } from '../../../hooks/useAISettings';

export function APIKeySettings() {
  const [showKey, setShowKey] = useState(false);
  const { chatbotPublicId } = useChatbot();
  const { apiKey, updateAPIKey, loading } = useAISettings();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!chatbotPublicId) return;
    
    const formData = new FormData(e.currentTarget);
    const key = formData.get('apiKey') as string;
    updateAPIKey(key, chatbotPublicId);
  };

  // Toujours afficher la clé masquée
  const maskedKey = '•'.repeat(40);

  return (
    <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
      <h3 className="text-lg font-semibold text-white mb-4">OpenAI API key</h3>
      <div className="text-gray-400 mb-4">
        <p>A default API key is configured to allow you to test the chatbot.</p>
        <p>To use your own API key, enter it below.</p>
      </div>
      <div className="space-y-4">
        <div>
          <div className="relative">
            <input
              type="text"
              value={maskedKey}
              className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 pr-10"
              disabled
            />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              New API key (optional)
            </label>
            <div className="relative">
              <input
                type={showKey ? 'text' : 'password'}
                name="apiKey"
                placeholder="sk-..."
                className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 pr-10"
              />
              <button
                type="button"
                onClick={() => setShowKey(!showKey)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors"
              >
                {showKey ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="bg-indigo-500/20 text-indigo-400 px-4 py-2 rounded-lg hover:bg-indigo-500/30 transition-colors disabled:opacity-50"
          >
            {loading ? 'Saving...' : 'Save the key'}
          </button>
        </form>
      </div>
    </div>
  );
}